import { FunctionalComponent } from 'preact'
import { LibraryWidgetMetadata } from '@insided/customization'
import { CategoryListItem } from './CategoryListItem'

export interface WidgetsFilterProps {
  selectedCategory: string | null
  availableWidgets: LibraryWidgetMetadata[]
  categories: string[]
  onClick: (category: string | null) => void
}

export const WidgetCategoryFilter: FunctionalComponent<WidgetsFilterProps> = ({
  selectedCategory,
  categories,
  availableWidgets,
  onClick
}) => {
  return (
    <ul className='widgets-library-sidebar'>
      <CategoryListItem
        label='All'
        count={availableWidgets.length}
        active={selectedCategory === null}
        onClick={() => onClick(null)}
      />
      {categories.map((category) => (
        <CategoryListItem
          key={category}
          label={category}
          count={availableWidgets.filter((widget) => widget.category === category).length}
          active={selectedCategory === category}
          onClick={() => onClick(category)}
        />
      ))}
    </ul>
  )
}
